import { QPInfoManager } from 'qunar-react-native';

const qpVersionCache: { [propName: string]: any } = {};

const getQpVersion = (hybridId = 'cmn_order_rn') =>
    new Promise((resolve) => {
        if (qpVersionCache[hybridId]) {
            resolve(qpVersionCache[hybridId]);
        } else {
            QPInfoManager.getQpInfo(
                hybridId,
                (qpInfo: { version: number }) => {
                    const { version } = qpInfo || {};
                    qpVersionCache[hybridId] = version;
                    resolve(version);
                },
                () => {
                    resolve('');
                }
            );
        }
    });

export default getQpVersion;
